import { debounce } from "common/functions";
import { RefObject, useEffect, useRef } from "react";

function useEventListener<T extends HTMLElement>(
  eventName: keyof WindowEventMap,
  handler: (event: Event) => void,
  element?: RefObject<T>,
  debounceWait: number = 100 // Add debounce wait time as a parameter
) {
  // Create a ref that stores handler
  const savedHandler = useRef<(event: Event) => void>();

  useEffect(() => {
    // Define the listening target

    const targetElement: T | Window = element?.current || window;
    if (!(targetElement && targetElement.addEventListener)) {
      return;
    }

    // Update saved handler if necessary
    if (savedHandler.current !== handler) {
      savedHandler.current = handler;
    }

    // Create event listener that calls handler function stored in ref
    // const eventListener = (event: Event) => {
    //   // eslint-disable-next-line no-extra-boolean-cast
    //   if (!!savedHandler?.current) {
    //     savedHandler.current(event)
    //   }
    // }
    const eventListener = debounce((event: Event) => {
      if (savedHandler.current) {
        savedHandler.current(event);
      }
    }, debounceWait);

    targetElement.addEventListener(eventName, eventListener);

    // Remove event listener on cleanup
    return () => {
      targetElement.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element, handler]);
}

export default useEventListener;
